export const BASE_FONT_FAMILY = 'SamsungOne, sans-serif';
// 폰트 가중치와 크기 정의
export const FONT_WEIGHTS = {
    800: [40, 24, 18],
    700: [32, 24, 20, 18, 16, 14, 12],
    400: [16, 14, 12],
    200: [12],
};
//# sourceMappingURL=fonts.constants.js.map